export const AvatarNavbarFantasyMonstersIcon = ({
  className = '',
}: {
  className?: string
}) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_1460_91928)">
        <path
          d="M5.94 11.82C7.45 12.89 12.61 13.1 14.59 11.93"
          stroke="#737373"
          strokeWidth="1.15"
          strokeMiterlimit="10"
        />
        <path
          d="M5.64 13.15C2.9 13.73 1.04 14.81 1.04 16.04C1.04 17.88 5.15 19.38 10.21 19.38C15.27 19.38 19.37 17.88 19.37 16.04C19.37 14.81 17.56 13.74 14.82 13.16"
          stroke="#737373"
          strokeWidth="1.15"
          strokeMiterlimit="10"
        />
        <path
          d="M11.04 6.04C11.04 6.04 17.81 7.55 18.54 6.04C18.96 4.95 12.45 1.04 10.21 1.04C7.97 1.04 5.21 15.21 5.21 15.21C5.21 15.21 6.53 16.04 10.21 16.04C13.89 16.04 15.21 15.21 15.21 15.21L13.56 6.49"
          stroke="#737373"
          strokeWidth="1.15"
          strokeMiterlimit="10"
        />
      </g>
      <defs>
        <clipPath id="clip0_1460_91928">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
